import CreditCardIcon from "assets/images/components/CreditCardIcon";
import TitleSection from "components/TitleSection";

import React from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";

// TODO:  format numbers by locale

const Result = ({ result }) => {
  const { t } = useTranslation();
  return (
    <div className="result h-100 flex-column">
      <TitleSection title={t("dashboard.result.title")} Icon={CreditCardIcon} />
      <div className="result__container flex-column h-100">
        <div className="flex-column h-100">
          <div className="result__background" />
          <div className="flex-row result__top ">
            <div className="flex-column reverse  ml-auto result__top-column">
              <div className="result__top--text result__text ml-auto">
                <div className="result__text--info">{t("dashboard.result.topright")}</div>
                <h2>€ {result.neutral}</h2>
              </div>
              <div className="result__top--border result__border  ml-auto"></div>
            </div>
          </div>
        </div>
        <div className="flex-row result__bottom">
          <div className="flex-column result__bottom-left">
            <div className="result__bottom-left--border result__border"></div>
            <div className="result__bottom-left--text result__text">
              <div className="result__text--info">{t("dashboard.result.bottomleft")}</div>             
              <h2>€ {result.pesimistic}</h2>
            </div>
          </div>
          <div className="flex-column result__bottom-right ml-auto">
            <div className="result__bottom-right--border result__border"></div>
            <div className="result__bottom-right--text result__text">
              <div className="result__text--info">{t("dashboard.result.bottomright")}</div>
              <h2>€ {result.optimistic}</h2>
            </div>
          </div>
        </div>
      </div>
      <p>{t("dashboard.result.summary-1")}</p>
      <p>{t("dashboard.result.summary-2")}</p>
    </div>
  );
};

export default Result;
